import { NETWORK_CATEGORIES } from "../../data/content";
import { ChapterLabel, Container, FadeUp, MaskedLine } from "./ui";

const MarqueeRow = ({ ariaHidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
    {NETWORK_CATEGORIES.map((c) => (
      <span key={`${c}-${ariaHidden}`} className="flex items-center">
        <span className="whitespace-nowrap font-serif text-3xl font-medium text-white/[0.16] transition-colors md:text-5xl">
          {c}
        </span>
        <span className="mx-8 h-1 w-1 rounded-full bg-champagne/50 md:mx-12" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Network = () => (
  <section className="overflow-hidden bg-surface py-28 md:py-40" data-testid="network-section">
    <Container>
      <ChapterLabel num="10" label="The Network" />
      <h2 className="mt-10 max-w-[900px] font-serif font-medium leading-[0.95] text-ivory text-[clamp(38px,4.8vw,76px)]">
        <MaskedLine delay={0.1}>THE RIGHT PEOPLE</MaskedLine>
        <MaskedLine delay={0.2} className="text-champagne">
          FOR THE RIGHT REQUEST.
        </MaskedLine>
      </h2>
      <FadeUp delay={0.25} className="mt-8">
        <p className="max-w-[560px] font-sans text-[15px] font-light leading-[1.8] text-neutral-400 md:text-base">
          Nous ne cherchons pas à proposer un catalogue infini.
        </p>
        <p className="mt-4 max-w-[560px] font-sans text-[15px] font-light leading-[1.8] text-neutral-400 md:text-base">
          Nous sélectionnons les partenaires pertinents pour chaque demande, selon leur
          expertise, leur disponibilité, leur niveau de service et les contraintes de la mission.
        </p>
      </FadeUp>
    </Container>

    <FadeUp delay={0.2} className="mt-16 md:mt-20" y={20}>
      <div className="border-y border-line py-8 md:py-10" data-testid="network-marquee">
        <div className="flex w-max animate-marquee">
          <MarqueeRow />
          <MarqueeRow ariaHidden />
        </div>
      </div>
    </FadeUp>
  </section>
);

export default Network;
